export default __webpack_public_path__ + "media/color/cdt-e4535602.svg";